import PropTypes from 'prop-types';
import React from 'react';
import Button from '../components/Button';
import { Color } from '../../constants/components';

const LogoutButton = props => (
    <Button {...props} text="Log Out" color={Color.DARK_GREY} ariaLabel="Log out" />
);

LogoutButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
};

LogoutButton.defaultProps = {
    className: 'modal-btn',
};

export default LogoutButton;
